mutation CreateAllDataUploadRowRecords($id: ID!) {
  createAllDataUploadRowRecords(input: { id: $id }) {
    success
  }
}
